import styled from 'styled-components';

const DefaultBox = styled.span`
	color: ${props => props.theme.colors.brandSecondary};
	font-size: 22px;
    line-height: 32px;
    font-family: '888-Bold';
	text-shadow: -3px -2px 5px black;
`;


export const PartyJackpotWinCelebrationPopupTitleBox = DefaultBox;